window.addEventListener('load', () => {
  // Wrapin adds a div with #ptw-wrapin id, but we need to override it.
  // We need to delete the one added by the app, so our override will take effect.
  const wrapinDivs = document.querySelectorAll('#ptw-wrapin');
  wrapinDivs.forEach((wrapinDiv) => {
    if (!wrapinDiv.hasAttribute('data-strangeanimals-override')) {
      wrapinDiv.remove();
    }
  });
});